import type { i18n as i18nInstance } from "i18next";
import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";
import { LocalesConfig } from "../config/LocalesConfig";

const localesConfig = new LocalesConfig();

export const i18n: i18nInstance = createInstance({
  fallbackLng: localesConfig.defaultLanguage,
  lng: localesConfig.resolveLanguage(),
  resources,
});

i18n.use(initReactI18next).init().then();
